"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "DataExportController", {
    enumerable: true,
    get: function() {
        return DataExportController;
    }
});
const _common = require("@nestjs/common");
const _globalguard = require("~/guards/global/global.guard");
const _extractidsmiddleware = require("~/middlewares/extract-ids/extract-ids.middleware");
const _basesservice = require("~/services/bases.service");
const _models = require("~/models");
const _Jobs = require("~/interface/Jobs");
const _metaapilimiterguard = require("~/guards/meta-api-limiter.guard");
const _jobsserviceinterface = require("~/modules/jobs/jobs-service.interface");
const _tenantcontextdecorator = require("~/decorators/tenant-context.decorator");
const _config = require("~/interface/config");
const _catchError = require("~/helpers/catchError");
function _extends() {
    _extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source){
                if (Object.prototype.hasOwnProperty.call(source, key)) {
                    target[key] = source[key];
                }
            }
        }
        return target;
    };
    return _extends.apply(this, arguments);
}
function _ts_decorate(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
}
function _ts_metadata(k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
}
function _ts_param(paramIndex, decorator) {
    return function(target, key) {
        decorator(target, key, paramIndex);
    };
}
let DataExportController = class DataExportController {
    async exportModelData(context, req, viewId, exportAs, options) {
        const view = await _models.View.get(context, viewId);
        if (!view) _catchError.NcError.viewNotFound(viewId);
        const job = await this.jobsService.add(_Jobs.JobTypes.DataExport, {
            context,
            options: _extends({}, options != null ? options : {}, {
                // includeByteOrderMark when export is triggered from controller
                includeByteOrderMark: true
            }),
            modelId: view.fk_model_id,
            viewId,
            user: req.user,
            exportAs,
            ncSiteUrl: req.ncSiteUrl
        });
        return {
            id: job.id,
            name: job.name
        };
    }
    constructor(jobsService, basesService){
        this.jobsService = jobsService;
        this.basesService = basesService;
    }
};
_ts_decorate([
    (0, _common.Post)([
        '/api/v2/export/:viewId/:exportAs'
    ]),
    (0, _common.HttpCode)(200),
    (0, _extractidsmiddleware.Acl)('dataList'),
    _ts_param(0, (0, _tenantcontextdecorator.TenantContext)()),
    _ts_param(1, (0, _common.Req)()),
    _ts_param(2, (0, _common.Param)('viewId')),
    _ts_param(3, (0, _common.Param)('exportAs')),
    _ts_param(4, (0, _common.Body)()),
    _ts_metadata("design:type", Function),
    _ts_metadata("design:paramtypes", [
        typeof _config.NcContext === "undefined" ? Object : _config.NcContext,
        typeof _config.NcRequest === "undefined" ? Object : _config.NcRequest,
        String,
        String,
        Object
    ]),
    _ts_metadata("design:returntype", Promise)
], DataExportController.prototype, "exportModelData", null);
DataExportController = _ts_decorate([
    (0, _common.Controller)(),
    (0, _common.UseGuards)(_metaapilimiterguard.MetaApiLimiterGuard, _globalguard.GlobalGuard),
    _ts_param(0, (0, _common.Inject)('JobsService')),
    _ts_metadata("design:type", Function),
    _ts_metadata("design:paramtypes", [
        typeof _jobsserviceinterface.IJobsService === "undefined" ? Object : _jobsserviceinterface.IJobsService,
        typeof _basesservice.BasesService === "undefined" ? Object : _basesservice.BasesService
    ])
], DataExportController);
